import { render, staticRenderFns } from "./contest.vue?vue&type=template&id=c59af06e&scoped=true"
import script from "./contest.vue?vue&type=script&lang=js"
export * from "./contest.vue?vue&type=script&lang=js"
import style0 from "./contest.vue?vue&type=style&index=0&id=c59af06e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c59af06e",
  null
  
)

export default component.exports